// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bszaE","input":"styles_input__2vpZm"};